import { render, staticRenderFns } from "./ForceSyncSingleBCModal.vue?vue&type=template&id=1ae0a151&"
import script from "./ForceSyncSingleBCModal.vue?vue&type=script&lang=js&"
export * from "./ForceSyncSingleBCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports